import { render } from "./register.html?vue&type=template&id=72990457&ts=true"
import script from "./register.ts?vue&type=script&lang=ts"
export * from "./register.ts?vue&type=script&lang=ts"

import "./register.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__